class BookingPaymentDisagioComponent extends Component
{

    component_interface;

    constructor() {
        super(BookingPaymentDisagioComponent, '.booking_payment_method_disagio_checkbox');
        this.component_interface = new BookingPaymentMethodDisagioInterface();
        this.registerListeners();
    }



    registerListeners() {
        super.registerListeners();

        let checkbox_listener = new BookingPaymentMethodDisagioCheckboxListener(
            '.booking_payment_method_disagio_checkbox',
            this.component_interface
        );

    }


}

$(document).ready(function (e){
    Components.addComponent(
        new BookingPaymentDisagioComponent()
    );
});

